import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import SocialIcons from "./SocialIcons";
import { FaRegCopy } from "react-icons/fa6";
import { IoCheckmarkDone } from "react-icons/io5";
import { RxCross1 } from "react-icons/rx";
import { copyToClipboard } from "../../../utils/clipboard";
import { buildEventShareUrl } from "../../Home/chatEventLinks";

const labelClass =
  "block text-[11px] text-white/70 uppercase tracking-wider mb-3 font-semibold";

const ShareModal = ({ setShow, item, Share }) => {
  const [copy, setCopy] = useState(false);
  const shareUrl = buildEventShareUrl(item);
  const eventName = item?.name || "this event";

  useEffect(() => {
    if (!copy) return undefined;
    const timer = setTimeout(() => setCopy(false), 3000);
    return () => clearTimeout(timer);
  }, [copy]);

  return createPortal(
    <div className="fixed inset-0 z-[10000000] flex items-center justify-center bg-black/65 backdrop-blur-sm p-4">
      <div className="relative w-full max-w-md max-h-[90vh] overflow-y-auto rounded-2xl bg-[#0B1120] border border-[#1a2744] shadow-2xl shadow-black/50">
        <div className="sticky top-0 z-10 flex items-start justify-between gap-3 px-5 py-4 border-b border-[#1a2744] bg-[#0B1120]">
          <div className="min-w-0">
            <h3 className="text-[18px] font-bold text-white tracking-tight">
              Share Event
            </h3>
            <p className="mt-1 text-[13px] text-white/50 truncate" title={eventName}>
              {eventName}
            </p>
          </div>
          <button
            type="button"
            aria-label="Close"
            className="shrink-0 p-1.5 rounded-lg text-white/50 hover:text-white hover:bg-white/[0.08] transition-all cursor-pointer"
            onClick={() => setShow(false)}
          >
            <RxCross1 className="text-[22px]" />
          </button>
        </div>

        <div className="px-5 py-6 space-y-6">
          <div>
            <p className={labelClass}>Share this link via</p>
            <div className="flex justify-center py-2">
              <SocialIcons item={item} Share={Share} />
            </div>
          </div>

          <div>
            <p className={labelClass}>Or copy link</p>
            <div className="flex items-stretch gap-2 rounded-xl overflow-hidden border border-white/[0.12] bg-white/[0.04]">
              <input
                className="flex-1 min-w-0 px-4 py-3 text-[13px] text-white/80 bg-transparent border-none outline-none"
                value={shareUrl}
                readOnly
                aria-label="Event share link"
              />
              <button
                type="button"
                className={`shrink-0 px-4 flex items-center justify-center gap-2 text-[13px] font-semibold transition-colors ${
                  copy
                    ? "bg-emerald-600/90 text-white"
                    : "bg-[#E52324] hover:bg-[#d11f20] text-white"
                }`}
                onClick={async () => {
                  if (copy) return;
                  const success = await copyToClipboard(shareUrl);
                  if (success) setCopy(true);
                }}
                aria-label={copy ? "Link copied" : "Copy link"}
              >
                {copy ? (
                  <>
                    <IoCheckmarkDone className="text-[18px]" />
                    <span className="hidden sm:inline">Copied</span>
                  </>
                ) : (
                  <>
                    <FaRegCopy className="text-[18px]" />
                    <span className="hidden sm:inline">Copy</span>
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ShareModal;
